// Brazilian Portuguese UI catalog — generated from the English strings used in the JSX (English text is the key).
// Regenerate the key list with scripts/i18n-keys.mjs; keep entries in English order.
export const ptBR: Record<string, string> = {
  "Active only": "Somente ativas",
  "Attach files": "Anexar arquivos",
  "Attach files to the comment; you can also paste or drop them into it": "Anexe arquivos ao comentário; você também pode colá-los ou soltá-los nele",
  "Attach files to this task; you can also drop them here": "Anexe arquivos a esta tarefa; você também pode soltá-los aqui",
  "Attachments": "Anexos",
  "Delete {name}?": "Excluir {name}?",
  "Download": "Baixar",
  "No files yet. Drop files here or use Attach files.": "Ainda não há arquivos. Solte arquivos aqui ou use Anexar arquivos.",
  "No files.": "Nenhum arquivo.",
  "Remove this file": "Remover este arquivo",
  "Show only tasks in progress, hiding the backlog and done. Remembered, and shared by the task views.": "Mostrar só tarefas em andamento, ocultando o backlog e as concluídas. A escolha é lembrada e compartilhada pelas visões de tarefas.",
  "Hide tasks that are done. Remembered, and shared by the task views.": "Ocultar as tarefas concluídas. A escolha é lembrada e compartilhada pelas visões de tarefas.",
  "Show backlog": "Mostrar backlog",
  "Upload failed": "Falha no envio",
  "Uploading 1 file…": "Enviando 1 arquivo…",
  "Uploading {n} files…": "Enviando {n} arquivos…",
  "With \"Active only\" on, also show tasks still in the backlog. Remembered.": "Com \"Somente ativas\" ligado, mostrar também as tarefas ainda no backlog. A escolha é lembrada.",
  "Markdown · type @ to mention someone · Ctrl-Enter posts": "Markdown · digite @ para mencionar alguém · Ctrl-Enter publica",
  "Nothing to preview yet.": "Ainda não há nada para pré-visualizar.",
  "Show the comment formatted, as it will appear": "Mostrar o comentário formatado, como ele vai aparecer",
  "Write": "Escrever",
  "in a comment": "em um comentário",
  "nav.home": "Início",
  "nav.time": "Tempo",
  "nav.timesheets": "Folhas de horas",
  "nav.leave": "Ausências",
  "nav.reports": "Relatórios",
  "nav.projects": "Projetos",
  "nav.people": "Pessoas",
  "nav.payroll": "Folha",
  "nav.admin": "Admin",
  "nav.signout": "Sair",
  "nav.portfolios": "Portfólios",
  "1 year": "1 ano",
  "30 days": "30 dias",
  "90 days": "90 dias",
  "A token lets Claude Code (or a script) act as you through the API: projects, portfolios, tasks, schedules, links, milestones and your time. It never reaches rates, budgets, payroll, approvals, admin or account settings, whatever your role.": "Um token permite que o Claude Code (ou um script) atue como você pela API: projetos, portfólios, tarefas, cronogramas, vínculos, marcos e o seu tempo. Ele nunca alcança taxas, orçamentos, folha de pagamento, aprovações, administração ou configurações da conta, seja qual for o seu papel.",
  "Create token": "Criar token",
  "Created": "Criado",
  "Dismiss": "Fechar",
  "Read tokens can only look; write tokens can also create and change tasks, links, milestones and time entries. Everything a token does is audited as you, marked with the token's name.": "Tokens de leitura só podem consultar; tokens de escrita também podem criar e alterar tarefas, vínculos, marcos e lançamentos de tempo. Tudo o que um token faz é auditado como você, marcado com o nome do token.",
  "Read: look only. Write: create and change tasks, links, milestones and time": "Leitura: só consultar. Escrita: criar e alterar tarefas, vínculos, marcos e tempo",
  "Revoke": "Revogar",
  "Revoked:": "Revogados:",
  "Scope": "Escopo",
  "The token is shown once, when you create it. Revoke it here if it leaks.": "O token é exibido uma única vez, ao ser criado. Revogue-o aqui se vazar.",
  "Then start Claude Code and ask it, for example, \"what is overdue across my portfolio?\" or \"plan the importer epic in DEN with four tasks and link them\".": "Depois abra o Claude Code e peça, por exemplo, “o que está atrasado no meu portfólio?” ou “planeje o épico do importador em DEN com quatro tarefas e vincule-as”.",
  "To use it from Claude Code, put it in your shell and add the server once:": "Para usá-lo no Claude Code, coloque-o no seu shell e adicione o servidor uma vez:",
  "Token": "Token",
  "Token name, e.g. Claude Code on my laptop": "Nome do token, ex.: Claude Code no meu notebook",
  "When the token stops working on its own": "Quando o token deixa de funcionar por conta própria",
  "created. Copy it now — it will not be shown again.": "criado. Copie agora — não será mostrado de novo.",
  "for Claude Code and scripts": "para o Claude Code e scripts",
  "login.title": "Entrar",
  "never expires": "nunca expira",
  "read and write": "leitura e escrita",
  "read only": "somente leitura",
  "via API token": "via token de API",
  "login.email": "E-mail",
  "login.password": "Senha",
  "login.button": "Entrar",
  "login.google": "Continuar com o Google",
  "login.passkey": "Entrar com chave de acesso",
  "login.or": "ou use uma senha",
  "common.save": "Salvar",
  "common.cancel": "Cancelar",
  "common.delete": "Excluir",
  "common.edit": "Editar",
  "common.add": "Adicionar",
  "common.loading": "Carregando…",
  "time.start": "Iniciar cronômetro",
  "time.stop": "Parar e salvar",
  "time.thisWeek": "Esta semana",
  "offline.queued": "{n} lançamento de tempo na fila — será enviado quando você voltar a ficar online",
  "offline.queuedPlural": "{n} lançamentos de tempo na fila — serão enviados quando você voltar a ficar online",
  "+ Add": "+ Adicionar",
  "+ Task": "+ Tarefa",
  "1 person notified": "1 pessoa notificada",
  "1 private project hidden": "1 projeto privado oculto",
  "1 private project is hidden from these totals.": "1 projeto privado está oculto destes totais.",
  "1 project": "1 projeto",
  "1. Scan the code with your authenticator app, or enter this key manually:": "1. Escaneie o código com seu app autenticador ou digite esta chave manualmente:",
  "13 weeks": "13 semanas",
  "2. Enter the 6-digit code the app shows to confirm.": "2. Digite o código de 6 dígitos mostrado pelo app para confirmar.",
  "26 weeks": "26 semanas",
  "4 weeks": "4 semanas",
  "8 weeks": "8 semanas",
  "A flag is a named on/off switch you control here without a deploy. Every signed-in browser receives the current flags, and features can check them to show or hide something.": "Um sinalizador é um interruptor nomeado que você controla aqui sem fazer deploy. Todo navegador conectado recebe os sinalizadores atuais, e os recursos podem consultá-los para mostrar ou ocultar algo.",
  "A person is": "Uma pessoa está",
  "A portfolio groups related projects under one initiative (a client, a programme, a department) with a shared board, list and Gantt.": "Um portfólio agrupa projetos relacionados sob uma iniciativa (um cliente, um programa, um departamento) com quadro, lista e Gantt compartilhados.",
  "A portfolio groups related projects under one initiative (a client, a programme, a department).": "Um portfólio agrupa projetos relacionados sob uma iniciativa (um cliente, um programa, um departamento).",
  "A private project appears only in your own project list — no one else can see it, whatever their role": "Um projeto privado aparece apenas na sua própria lista de projetos — ninguém mais pode vê-lo, seja qual for o papel",
  "A simple sub-task with its own key; it appears here, not on the board": "Uma subtarefa simples com chave própria; ela aparece aqui, não no quadro",
  "A token acts as this person through the API: projects, portfolios, tasks, schedules and their time, never rates, payroll or admin. Everything it does is audited as them, marked with the token's name, and your name is recorded as the one who issued it.": "Um token atua como esta pessoa pela API: projetos, portfólios, tarefas, cronogramas e o tempo dela, nunca taxas, folha de pagamento ou administração. Tudo o que ele faz é auditado como ela, marcado com o nome do token, e o seu nome fica registrado como quem o emitiu.",
  "API tokens": "Tokens de API",
  "Account": "Conta",
  "Accounts are invite-only. If you have an invite link, open it to set up your account.": "As contas são apenas por convite. Se você tem um link de convite, abra-o para configurar sua conta.",
  "Action": "Ação",
  "Actions": "Ações",
  "Add": "Adicionar",
  "Add a comment": "Adicionar um comentário",
  "Add a milestone on this day": "Adicionar um marco neste dia",
  "Add a person": "Adicionar uma pessoa",
  "Add a person…": "Adicionar uma pessoa…",
  "Add a status column (columns are the project's statuses)": "Adicionar uma coluna de status (as colunas são os status do projeto)",
  "Add a subtask under this task": "Adicionar uma subtarefa sob esta tarefa",
  "Add a task due on this day": "Adicionar uma tarefa com vencimento neste dia",
  "Add a task in this column": "Adicionar uma tarefa nesta coluna",
  "Add a top-level task": "Adicionar uma tarefa de nível superior",
  "Add checklist item": "Adicionar item da lista",
  "Add column": "Adicionar coluna",
  "Add entry": "Adicionar lançamento",
  "Add holiday": "Adicionar feriado",
  "Add project…": "Adicionar projeto…",
  "Add rate": "Adicionar taxa",
  "Add subtask": "Adicionar subtarefa",
  "Add task": "Adicionar tarefa",
  "Add the column at the end; drag its header to reorder": "Adiciona a coluna no fim; arraste o cabeçalho para reordenar",
  "Add the item": "Adicionar o item",
  "Added": "Adicionado",
  "Address / CIDR": "Endereço / CIDR",
  "Addresses on file (restriction currently off):": "Endereços registrados (restrição desativada no momento):",
  "Adds a second step to password sign-in: a 6-digit code from an app such as Google Authenticator, 1Password or Authy.": "Adiciona uma segunda etapa ao login com senha: um código de 6 dígitos de um app como Google Authenticator, 1Password ou Authy.",
  "Admin console": "Console de administração",
  "After": "Depois",
  "Alert at %": "Alertar em %",
  "All portfolios you can see; create one there": "Todos os portfólios que você pode ver; crie um por lá",
  "All projects": "Todos os projetos",
  "All states": "Todos os estados",
  "Amount": "Valor",
  "An account for an integration, left out of payroll, timesheets and scheduled reports": "Uma conta para uma integração: fica fora da folha, das folhas de horas e dos relatórios agendados",
  "An invite lets them pick their own password. Creating an account here sends no email at all: it exists straight away, and you decide whether it has a password.": "Um convite deixa a pessoa escolher a própria senha. Criar uma conta aqui não envia e-mail nenhum: ela existe na hora e você decide se tem senha.",
  "Analytics": "Análises",
  "Any action": "Qualquer ação",
  "Any milestone": "Qualquer marco",
  "Any priority": "Qualquer prioridade",
  "Any project": "Qualquer projeto",
  "Any status": "Qualquer status",
  "Anyone": "Qualquer pessoa",
  "Approvals": "Aprovações",
  "Approve although it was not submitted — you'll be warned if the week is empty or thin, and the person is notified": "Aprovar mesmo sem envio — você será avisado se a semana estiver vazia ou curta, e a pessoa é notificada",
  "Approve without submission?": "Aprovar sem envio?",
  "Approve — locks the week; any later work must be a correction entry": "Aprovar — bloqueia a semana; qualquer trabalho posterior deve ser um lançamento de correção",
  "Approve — reduces their available capacity for those days": "Aprovar — reduz a capacidade disponível dessa pessoa nesses dias",
  "Approved": "Aprovado",
  "Archive": "Arquivar",
  "Archive this portfolio? Its projects are unchanged; the portfolio drops out of the default lists.": "Arquivar este portfólio? Seus projetos não mudam; o portfólio sai das listas padrão.",
  "Assign to…": "Atribuir a…",
  "Assignee": "Responsável",
  "At a glance": "Visão rápida",
  "At least 12 characters. A password found in a public breach is refused.": "Pelo menos 12 caracteres. Uma senha encontrada em um vazamento público é recusada.",
  "At least 12 characters. A short sentence works well.": "Pelo menos 12 caracteres. Uma frase curta funciona bem.",
  "Auto-schedule": "Agendamento automático",
  "Avatar URL": "URL do avatar",
  "Awaiting approval": "Aguardando aprovação",
  "Awaiting your approval": "Aguardando sua aprovação",
  "Back": "Voltar",
  "Back to portfolios": "Voltar aos portfólios",
  "Back to projects": "Voltar aos projetos",
  "Baseline": "Linha de base",
  "Before": "Antes",
  "Bill rates": "Taxas de faturamento",
  "Billable + non": "Faturável + não",
  "Billable only": "Somente faturável",
  "Billable value": "Valor faturável",
  "Board": "Quadro",
  "Breadcrumb": "Trilha de navegação",
  "Budget": "Orçamento",
  "Bulk-load people, projects, and an opening task backlog from CSV files.": "Carregue em massa pessoas, projetos e um backlog inicial de tarefas a partir de arquivos CSV.",
  "Calendar": "Calendário",
  "Calendar settings": "Configurações do calendário",
  "Cancel": "Cancelar",
  "Cancel this pending invite": "Cancelar este convite pendente",
  "Cancel this request (or approved leave that hasn't started)": "Cancelar esta solicitação (ou ausência aprovada que ainda não começou)",
  "Capacity": "Capacidade",
  "Category": "Categoria",
  "Change any field on this person's record, including their email": "Alterar qualquer campo do registro desta pessoa, inclusive o e-mail",
  "Change password": "Alterar senha",
  "Change the email for {name} to {email}? That address is where password resets go, and they are told about the change.": "Alterar o e-mail de {name} para {email}? É para esse endereço que vão as redefinições de senha, e a pessoa é avisada da mudança.",
  "Changes save as you edit; this confirms and closes the editor": "As alterações são salvas enquanto você edita; isto confirma e fecha o editor",
  "Checking invite…": "Verificando convite…",
  "Checking…": "Verificando…",
  "Choose the timezone carefully — it cannot be changed afterwards.": "Escolha o fuso horário com cuidado — ele não pode ser alterado depois.",
  "Clear": "Limpar",
  "Click": "Clique",
  "Click the": "Clique em",
  "Close": "Fechar",
  "Code": "Código",
  "Collapse": "Recolher",
  "Collapse this card": "Recolher este cartão",
  "Collapse this section (remembered for you)": "Recolher esta seção (lembrado para você)",
  "Colour": "Cor",
  "Owner": "Responsável",
  "Colour the task bars by owner (assignee). Remembered.": "Colorir as barras de tarefas por responsável (pessoa atribuída). Fica lembrado.",
  "Colour for this calendar's events": "Cor dos eventos deste calendário",
  "Column (status) name shown on the board": "Nome da coluna (status) mostrado no quadro",
  "Column name": "Nome da coluna",
  "Command": "Comando",
  "Command palette": "Paleta de comandos",
  "Comment": "Comentário",
  "Comment deleted": "Comentário excluído",
  "Comment deleted by {name}": "Comentário excluído por {name}",
  "Comments": "Comentários",
  "Commit": "Confirmar",
  "Company holidays": "Feriados da empresa",
  "Completed": "Concluído",
  "Confirm new password": "Confirmar nova senha",
  "Confirm password": "Confirmar senha",
  "Connect Google Calendar": "Conectar Google Agenda",
  "Connecting failed. Try again.": "Falha ao conectar. Tente novamente.",
  "Continue with Google": "Continuar com o Google",
  "Copied": "Copiado",
  "Copy all": "Copiar tudo",
  "Copy link": "Copiar link",
  "Copy password": "Copiar senha",
  "Copy the claude mcp add command": "Copiar o comando claude mcp add",
  "Copy the export line": "Copiar a linha export",
  "Copy the password so you can pass it on": "Copiar a senha para repassá-la",
  "Copy the token": "Copiar o token",
  "Correct…": "Corrigir…",
  "Cost rate": "Taxa de custo",
  "Cost rates": "Taxas de custo",
  "Could not create portfolio": "Não foi possível criar o portfólio",
  "Could not load the overview.": "Não foi possível carregar a visão geral.",
  "Create a one-time invite link (7 days) and email it if mail is configured": "Criar um link de convite de uso único (7 dias) e enviá-lo por e-mail se o e-mail estiver configurado",
  "Create a project — you'll choose its permanent timezone-of-truth": "Criar um projeto — você escolherá seu fuso horário de referência permanente",
  "Create a task scheduled today for one week; drag its bar to adjust": "Criar uma tarefa agendada hoje por uma semana; arraste a barra para ajustar",
  "Create a top-level task in this project; open it afterwards to set dates, assignee, estimate": "Criar uma tarefa de nível superior neste projeto; abra-a depois para definir datas, responsável e estimativa",
  "Create account": "Criar conta",
  "Create feed link": "Criar link do feed",
  "Create invite": "Criar convite",
  "Create one below, then file projects under it from a project's": "Crie um abaixo e depois arquive projetos nele a partir das",
  "Create one from the Portfolios page, then file projects under it from a project's": "Crie um na página Portfólios e depois inclua projetos nele em cada projeto, em",
  "Create project": "Criar projeto",
  "Create the account now — nobody is emailed": "Criar a conta agora — ninguém recebe e-mail",
  "Create the task": "Criar a tarefa",
  "Create the task in this column": "Criar a tarefa nesta coluna",
  "Create your personal feed link": "Criar seu link de feed pessoal",
  "Cumulative flow": "Fluxo cumulativo",
  "Cumulative flow, cycle time, burndown, velocity, forecast": "Fluxo cumulativo, tempo de ciclo, burndown, velocidade, previsão",
  "Currency": "Moeda",
  "Current password": "Senha atual",
  "Cycle (d)": "Ciclo (d)",
  "Dashboard, projects, members, settings": "Painel, projetos, membros, configurações",
  "Dashboard, tasks, members, milestones, settings": "Painel, tarefas, membros, marcos, configurações",
  "Date": "Data",
  "Dates": "Datas",
  "Dates in": "Datas em",
  "Day": "Dia",
  "Deactivate your account (history is kept); you will be asked to confirm": "Desativar sua conta (o histórico é mantido); você será solicitado a confirmar",
  "Decides whether this account can sign in the moment you create it": "Define se esta conta pode entrar assim que for criada",
  "Decline with a reason; the person is notified": "Recusar com um motivo; a pessoa é notificada",
  "Delete": "Excluir",
  "Delete column": "Excluir coluna",
  "Delete milestone": "Excluir marco",
  "Delete task": "Excluir tarefa",
  "Delete this column (only when empty)": "Excluir esta coluna (somente quando vazia)",
  "Delete this comment? Its replies stay.": "Excluir este comentário? As respostas a ele permanecem.",
  "Delete this milestone": "Excluir este marco",
  "Delete this task": "Excluir esta tarefa",
  "Delete this task (and its subtasks); logged time is kept": "Excluir esta tarefa (e suas subtarefas); o tempo registrado é mantido",
  "Resize the task list": "Redimensionar a lista de tarefas",
  "Drag to resize the task list; double-click to reset": "Arraste para redimensionar a lista de tarefas; clique duas vezes para redefinir",
  "Delete this task and its subtasks; logged time is kept": "Excluir esta tarefa e suas subtarefas; o tempo registrado é mantido",
  "Description": "Descrição",
  "Directory": "Diretório",
  "Discard": "Descartar",
  "Discuss this milestone": "Comentar este marco",
  "Discussion": "Discussão",
  "Display only — never changes which week an entry belongs to.": "Somente exibição — nunca muda a que semana um lançamento pertence.",
  "Does not match.": "Não confere.",
  "Done": "Concluído",
  "Download CSV": "Baixar CSV",
  "Download a JSON file with everything stored about you": "Baixar um arquivo JSON com tudo o que está armazenado sobre você",
  "Download as a PDF table": "Baixar como tabela PDF",
  "Download as an Excel workbook": "Baixar como pasta de trabalho do Excel",
  "Download everything stored about you — profile, memberships, time entries, tasks assigned, leave, approvals, notifications — as JSON.": "Baixe tudo o que está armazenado sobre você — perfil, participações, lançamentos de tempo, tarefas atribuídas, ausências, aprovações, notificações — como JSON.",
  "Download my data": "Baixar meus dados",
  "Download partial CSV": "Baixar CSV parcial",
  "Download these rows as CSV": "Baixar estas linhas como CSV",
  "Drag cards, or focus a card and press": "Arraste os cartões, ou foque um cartão e pressione",
  "Drag to change priority; Space + arrows works from the keyboard": "Arraste para mudar a prioridade; Espaço + setas funciona pelo teclado",
  "Drag to move between columns or reorder; Space + arrows works from the keyboard": "Arraste para mover entre colunas ou reordenar; Espaço + setas funciona pelo teclado",
  "Drop idle time — save up to the idle moment, then restart": "Descartar o tempo ocioso — salvar até o momento ocioso e reiniciar",
  "Due": "Vencimento",
  "Each status maps to a global category (to do / in progress / done / archived) so reporting works across projects. Keep at least one per category. Archived work is left out of every count and hidden unless asked for.": "Cada status corresponde a uma categoria global (a fazer / em andamento / concluído / arquivado) para que os relatórios funcionem entre projetos. Mantenha pelo menos um por categoria. Trabalho arquivado fica fora de todas as contagens e oculto, salvo quando pedido.",
  "Archived": "Arquivado",
  "Also show tasks in an archived status. Remembered, and shared by the task views and the board.": "Mostrar também as tarefas em um status arquivado. A escolha é lembrada e compartilhada pelas visões de tarefas e pelo quadro.",
  "Waterfall": "Cascata",
  "Lay linked tasks out left to right: any task that overlaps what its links allow moves later (keeping its length), then rows are ordered by start, linked ones in link order. Done and archived tasks stay put. Saved; press again after changes.": "Dispor as tarefas vinculadas da esquerda para a direita: qualquer tarefa que se sobreponha ao que seus vínculos permitem é adiada (mantendo a duração) e então as linhas são ordenadas pelo início, as vinculadas na ordem dos vínculos. Tarefas concluídas e arquivadas não se movem. Fica salvo; pressione de novo após mudanças.",
  "Waterfall:": "Cascata:",
  "rescheduled": "reagendadas",
  "reordered": "reordenadas",
  "Already a waterfall: nothing to change": "Já está em cascata: nada a mudar",
  "Could not reschedule the tasks": "Não foi possível reagendar as tarefas",
  "Auto-schedule:": "Agendamento automático:",
  "Already scheduled: nothing to change": "Já está agendado: nada a mudar",
  "Auto-schedule replans every open task: in-progress work first, then linked tasks as soon as their links allow and others from today, so nobody gets two tasks at once. Continue?": "O agendamento automático replaneja toda tarefa aberta: primeiro o trabalho em andamento, depois as vinculadas assim que seus vínculos permitem e as demais a partir de hoje, para que ninguém fique com duas tarefas ao mesmo tempo. Continuar?",
  "Plan the open tasks as soon as possible: linked ones right after their links allow, unlinked past or undated ones from today (undated take their estimate at 8h a day, or 5 days), future unlinked ones keep their start. Each person's tasks are queued, in-progress first and then by priority, so they never overlap, counting their other projects. Done and archived tasks stay put. Saved.": "Planejar o quanto antes as tarefas abertas: as vinculadas logo que seus vínculos permitem, as não vinculadas passadas ou sem datas a partir de hoje (as sem datas usam a estimativa a 8 h por dia, ou 5 dias), as futuras não vinculadas mantêm o início. As tarefas de cada pessoa entram em fila, primeiro as em andamento e depois por prioridade, para nunca se sobreporem, contando seus outros projetos. Tarefas concluídas e arquivadas não se movem. Fica salvo.",
  "working days": "dias úteis",
  "estimated": "estimadas",
  "Edit": "Editar",
  "Edit person": "Editar pessoa",
  "Edit your comment; the previous text is kept as history": "Edite seu comentário; o texto anterior fica guardado no histórico",
  "Elapsed": "Decorrido",
  "Email": "E-mail",
  "End this session and return to the sign-in page (other devices stay signed in)": "Encerrar esta sessão e voltar à página de login (outros dispositivos permanecem conectados)",
  "Ends": "Termina",
  "Enter the 6-digit code from your authenticator app, or one of your recovery codes.": "Digite o código de 6 dígitos do seu app autenticador ou um dos seus códigos de recuperação.",
  "Epic": "Épico",
  "Estimate (h)": "Estimativa (h)",
  "Every project-week approved": "Todas as semanas de projeto aprovadas",
  "Everyone": "Todos",
  "Everyone (admin)": "Todos (admin)",
  "Everyone in the range is approved — download the payroll CSV": "Todos no período estão aprovados — baixe o CSV da folha",
  "Everything on this person's record. Changes are audit-logged against your name.": "Tudo o que há no registro desta pessoa. As alterações ficam no log de auditoria em seu nome.",
  "Examples:": "Exemplos:",
  "Excludes people who still have unapproved weeks; they are named in the file header": "Exclui pessoas que ainda têm semanas não aprovadas; elas são nomeadas no cabeçalho do arquivo",
  "Expand": "Expandir",
  "Expand this card to see details": "Expandir este cartão para ver detalhes",
  "Expand this section (remembered for you)": "Expandir esta seção (lembrado para você)",
  "Expires": "Expira",
  "External calendars (in)": "Calendários externos (entrada)",
  "Feature flags": "Sinalizadores de recursos",
  "Field": "Campo",
  "Filter the list by project code or name": "Filtrar a lista por código ou nome do projeto",
  "Final step: deactivate the account now": "Última etapa: desativar a conta agora",
  "For an integration such as Claude Code rather than a colleague: it stays out of payroll, timesheets and scheduled reports.": "Para uma integração como o Claude Code, não para um colega: fica fora da folha, das folhas de horas e dos relatórios agendados.",
  "Format": "Formato",
  "From": "De",
  "From your calendar today": "Da sua agenda de hoje",
  "Global category this column maps to, so cross-project reports keep working": "Categoria global à qual esta coluna corresponde, para que relatórios entre projetos continuem funcionando",
  "Google did not grant offline access — remove ADKOM PM under your Google account’s third-party access, then connect again.": "O Google não concedeu acesso offline — remova o ADKOM PM do acesso de terceiros da sua conta Google e conecte novamente.",
  "Grant read-only access; today's meetings become one-click time entry suggestions": "Conceder acesso somente leitura; as reuniões de hoje viram sugestões de lançamento com um clique",
  "Group by": "Agrupar por",
  "Group the board into rows by assignee, epic or priority": "Agrupar o quadro em linhas por responsável, épico ou prioridade",
  "Has unapproved weeks": "Tem semanas não aprovadas",
  "Hidden projects are a personal view preference; nothing about the project changes": "Projetos ocultos são uma preferência pessoal de exibição; nada no projeto muda",
  "Hide subtasks": "Ocultar subtarefas",
  "Hide this milestone's discussion": "Ocultar a discussão deste marco",
  "Hide this project from your lists (just for you; the project is unchanged)": "Ocultar este projeto das suas listas (só para você; o projeto não muda)",
  "Hide this project's tasks": "Ocultar as tarefas deste projeto",
  "Hours": "Horas",
  "Hours (30d)": "Horas (30d)",
  "Hours for other members are visible to project administrators and managers.": "As horas de outros membros são visíveis a administradores de projeto e gerentes.",
  "Hours per week": "Horas por semana",
  "Hours/wk": "Horas/sem",
  "How much of their time the schedule may plan for.": "Quanto do tempo dela o cronograma pode planejar.",
  "IP allowlist set by an administrator": "Lista de IPs permitidos definida por um administrador",
  "Identifies this project's tasks on portfolio boards and Gantts": "Identifica as tarefas deste projeto nos quadros e Gantts de portfólio",
  "Import": "Importar",
  "Import in order: people → projects → tasks.": "Importe na ordem: pessoas → projetos → tarefas.",
  "In progress": "Em andamento",
  "Include accounts used by integrations, which are hidden by default": "Incluir as contas usadas por integrações, ocultas por padrão",
  "Invite": "Convidar",
  "Invite colleagues and manage roles.": "Convide colegas e gerencie papéis.",
  "Invite for": "Convite para",
  "Issue a token for this person and show it once": "Emitir um token para esta pessoa e mostrá-lo uma única vez",
  "Issue or revoke tokens that act as this person through the API": "Emitir ou revogar tokens que atuam como esta pessoa pela API",
  "Issues assigned to this GitHub user become tasks assigned to them.": "Issues atribuídas a este usuário do GitHub viram tarefas atribuídas a essa pessoa.",
  "Job title": "Cargo",
  "Jump to the current week": "Ir para a semana atual",
  "Jump to the top of the page": "Ir para o topo da página",
  "Jump to top": "Ir para o topo",
  "Kanban board across every project in the portfolio": "Quadro Kanban com todos os projetos do portfólio",
  "Kanban board: drag cards between status columns": "Quadro Kanban: arraste cartões entre colunas de status",
  "Keep": "Manter",
  "Keep the account": "Manter a conta",
  "Keep — count the idle time as work": "Manter — contar o tempo ocioso como trabalho",
  "Keeps this account out of payroll, timesheets and scheduled reports.": "Mantém esta conta fora da folha, das folhas de horas e dos relatórios agendados.",
  "Key": "Chave",
  "Kind": "Tipo",
  "Label": "Rótulo",
  "Language": "Idioma",
  "Last": "Último",
  "Last active": "Última atividade",
  "Last run": "Última execução",
  "Last sign-in": "Último login",
  "Last used": "Último uso",
  "Leave": "Ausências",
  "Leave it empty to follow the organisation's working week.": "Deixe vazio para seguir a semana de trabalho da organização.",
  "Line": "Linha",
  "List": "Lista",
  "Loading…": "Carregando…",
  "Log time →": "Registrar tempo →",
  "Logged": "Registrado",
  "Managed by": "Gerenciado por",
  "Manager": "Gerente",
  "Median cycle time": "Tempo de ciclo mediano",
  "Median lead time": "Lead time mediano",
  "Member": "Membro",
  "Members": "Membros",
  "Mention someone": "Mencionar alguém",
  "Milestone": "Marco",
  "Milestones": "Marcos",
  "Milestone…": "Marco…",
  "Mine open": "Minhas abertas",
  "Month": "Mês",
  "Month view of due dates, milestones and external calendars": "Visão mensal de vencimentos, marcos e calendários externos",
  "More actions for this row": "Mais ações para esta linha",
  "Move this status up one place": "Mover este status uma posição para cima",
  "Move up": "Mover para cima",
  "Moving a project out of a portfolio is refused while it has cross-project links": "Não é possível tirar um projeto de um portfólio enquanto ele tiver vínculos entre projetos",
  "My private projects": "Meus projetos privados",
  "My reports": "Meus relatórios",
  "My requests": "Minhas solicitações",
  "My tasks": "Minhas tarefas",
  "Name": "Nome",
  "New milestone": "Novo marco",
  "New password": "Nova senha",
  "New portfolio": "Novo portfólio",
  "New portfolio name": "Nome do novo portfólio",
  "New project": "Novo projeto",
  "New status": "Novo status",
  "New subtask": "Nova subtarefa",
  "New task": "Nova tarefa",
  "New task in": "Nova tarefa em",
  "New task title": "Título da nova tarefa",
  "New timer": "Novo cronômetro",
  "Next milestone": "Próximo marco",
  "Next month": "Próximo mês",
  "Next run": "Próxima execução",
  "Next week": "Próxima semana",
  "No comments yet.": "Ainda não há comentários.",
  "No completed work in the window yet.": "Ainda não há trabalho concluído na janela.",
  "No cost rate yet.": "Ainda não há taxa de custo.",
  "No data.": "Sem dados.",
  "No earlier versions.": "Não há versões anteriores.",
  "No feed link yet.": "Ainda não há link de feed.",
  "No hours budget set.": "Nenhum orçamento de horas definido.",
  "No members yet.": "Ainda não há membros.",
  "No milestones yet.": "Ainda não há marcos.",
  "No money budget set.": "Nenhum orçamento financeiro definido.",
  "No open milestones with a due date.": "Nenhum marco aberto com data de vencimento.",
  "No portfolios yet.": "Ainda não há portfólios.",
  "No projects filed here yet.": "Ainda não há projetos incluídos aqui.",
  "No projects in this portfolio yet.": "Ainda não há projetos neste portfólio.",
  "No projects match.": "Nenhum projeto corresponde.",
  "No projects yet.": "Ainda não há projetos.",
  "No projects.": "Nenhum projeto.",
  "No tasks yet.": "Ainda não há tarefas.",
  "No tasks.": "Nenhuma tarefa.",
  "No time in this range.": "Nenhum tempo neste período.",
  "No time in this window.": "Nenhum tempo nesta janela.",
  "No time matches.": "Nenhum tempo corresponde.",
  "No tokens yet.": "Ainda não há tokens.",
  "Non-billable only": "Somente não faturável",
  "None": "Nenhum",
  "None yet.": "Nada ainda.",
  "Not available — approvals are for project administrators.": "Indisponível — aprovações são para administradores de projeto.",
  "Not configured on this server.": "Não configurado neste servidor.",
  "Not enough history yet for a trend — the weekly chart appears after two weeks of entries.": "Ainda não há histórico suficiente para uma tendência — o gráfico semanal aparece após duas semanas de lançamentos.",
  "Not enough history yet for trends and forecasts — they firm up after a couple of weeks of tasks moving. What is here is exact, just short.": "Ainda não há histórico suficiente para tendências e previsões — elas se firmam após algumas semanas de movimentação de tarefas. O que está aqui é exato, só que curto.",
  "Not enough history yet — the chart appears once two project weeks have entries.": "Ainda não há histórico suficiente — o gráfico aparece quando duas semanas de projeto tiverem lançamentos.",
  "Not submitted": "Não enviado",
  "Note": "Observação",
  "Note (optional)": "Observação (opcional)",
  "Note saved onto the entry": "Observação salva no lançamento",
  "Note saved onto the time entry when you stop": "Observação salva no lançamento de tempo ao parar",
  "Notes": "Observações",
  "Nothing assigned to you.": "Nada atribuído a você.",
  "Nothing completed yet.": "Nada concluído ainda.",
  "Nothing here.": "Nada aqui.",
  "Nothing logged yet.": "Nada registrado ainda.",
  "Nothing recorded yet.": "Nada gravado ainda.",
  "Nothing yet.": "Nada ainda.",
  "Notifications": "Notificações",
  "Now click the task that must wait for": "Agora clique na tarefa que deve esperar por",
  "On enter": "Ao entrar",
  "One submission per project per week, in each project's own timezone.": "Um envio por projeto por semana, no fuso horário de cada projeto.",
  "Only ephemeral records are ever purged. Business history — time entries, approvals, tasks, the audit log, status transitions — is never touched.": "Somente registros efêmeros são expurgados. O histórico de negócio — lançamentos de tempo, aprovações, tarefas, o log de auditoria, transições de status — nunca é tocado.",
  "Only you can see these. Drag to prioritize.": "Só você pode ver estes. Arraste para priorizar.",
  "Open People": "Abrir Pessoas",
  "Open People: directory, roles, invites": "Abrir Pessoas: diretório, papéis, convites",
  "Open Projects": "Abrir Projetos",
  "Open Reports to slice logged time": "Abrir Relatórios para analisar o tempo registrado",
  "Open portfolio →": "Abrir portfólio →",
  "Open tasks": "Tarefas abertas",
  "Open the Gantt chart": "Abrir o gráfico de Gantt",
  "Open the Kanban board": "Abrir o quadro Kanban",
  "Open the Time page: edit timers, notes, tasks": "Abrir a página Tempo: editar cronômetros, observações, tarefas",
  "Open the portfolio": "Abrir o portfólio",
  "Open the portfolio: shared board, list and Gantt across its projects": "Abrir o portfólio: quadro, lista e Gantt compartilhados entre seus projetos",
  "Open the project": "Abrir o projeto",
  "Open the task": "Abrir a tarefa",
  "Outstanding": "Pendente",
  "Overdue": "Atrasadas",
  "Overview": "Visão geral",
  "Parent": "Pai",
  "Password": "Senha",
  "Paste CSV here…": "Cole o CSV aqui…",
  "Pause": "Pausar",
  "Pause this timer; time is kept": "Pausar este cronômetro; o tempo é mantido",
  "Pause; time is kept": "Pausar; o tempo é mantido",
  "Payroll export": "Exportação da folha",
  "Pending": "Pendente",
  "People": "Pessoas",
  "Per-project feeds:": "Feeds por projeto:",
  "Permanent. Create a new project to use a different zone.": "Permanente. Crie um novo projeto para usar outro fuso.",
  "Person": "Pessoa",
  "Person…": "Pessoa…",
  "Pick the range by": "Escolha o período por",
  "Portfolio": "Portfólio",
  "Portfolio manager": "Gerente do portfólio",
  "Portfolio not found, or you do not have access.": "Portfólio não encontrado, ou você não tem acesso.",
  "Portfolio role": "Papel no portfólio",
  "Portfolio roles grant access to the merged views; task edits still follow each project's own membership.": "Os papéis no portfólio dão acesso às visões combinadas; edições de tarefas continuam seguindo a participação em cada projeto.",
  "Portfolios": "Portfólios",
  "Portfolios don't affect approvals — they add a shared board, list and Gantt, and cross-project links.": "Portfólios não afetam aprovações — eles adicionam quadro, lista e Gantt compartilhados, além de vínculos entre projetos.",
  "Portfolios don't affect permissions or approvals — they are purely for organising and reporting.": "Portfólios não afetam permissões nem aprovações — servem apenas para organizar e relatar.",
  "Portfolios →": "Portfólios →",
  "Post the comment": "Publicar o comentário",
  "Post the comment (Ctrl-Enter)": "Publicar o comentário (Ctrl-Enter)",
  "Prev": "Ant.",
  "Preview": "Pré-visualizar",
  "Previous month": "Mês anterior",
  "Previous week": "Semana anterior",
  "Priority": "Prioridade",
  "Priority…": "Prioridade…",
  "Private projects filed here that only their owners can see": "Projetos privados incluídos aqui que só seus donos podem ver",
  "Private — only you can see this project": "Privado — só você pode ver este projeto",
  "Private — only you will see this project": "Privado — só você verá este projeto",
  "Progress": "Progresso",
  "Project": "Projeto",
  "Project colour": "Cor do projeto",
  "Project not found, or you do not have access.": "Projeto não encontrado ou você não tem acesso.",
  "Project not found.": "Projeto não encontrado.",
  "Project role": "Papel no projeto",
  "Project the new task belongs to": "Projeto ao qual a nova tarefa pertence",
  "Projected finish": "Término projetado",
  "Projects": "Projetos",
  "Projects not yet in a portfolio that you may update": "Projetos que você pode atualizar e que ainda não estão em um portfólio",
  "Projects you are a member of.": "Projetos dos quais você é membro.",
  "Projects you can see. Managers and admins see all.": "Projetos que você pode ver. Gerentes e admins veem todos.",
  "Purge immediately using the currently saved policy (not unsaved edits) and record the counts above": "Expurgar imediatamente com a política salva atualmente (não as edições não salvas) e registrar as contagens acima",
  "Push successors when a task moves": "Empurrar as sucessoras quando uma tarefa se move",
  "Range": "Período",
  "Rates are visible to managers and administrators.": "As taxas são visíveis a gerentes e administradores.",
  "Read this first.": "Leia isto primeiro.",
  "Read-only: today’s meetings appear as one-click suggestions on the Time page. Your entries flow back to any calendar through the": "Somente leitura: as reuniões de hoje aparecem como sugestões de um clique na página Tempo. Seus lançamentos voltam para qualquer calendário pelo",
  "Ready": "Pronto",
  "Recently completed": "Concluídas recentemente",
  "Regenerate": "Regenerar",
  "Regenerate link": "Regenerar link",
  "Regenerate recovery codes": "Regenerar códigos de recuperação",
  "Regenerate the secret link (old link stops working)": "Regenerar o link secreto (o link antigo para de funcionar)",
  "Remove": "Remover",
  "Remove item": "Remover item",
  "Remove this calendar": "Remover este calendário",
  "Remove this checklist item": "Remover este item da lista",
  "Remove this comment; its replies stay": "Remover este comentário; as respostas permanecem",
  "Repeats": "Repete",
  "Reply": "Responder",
  "Reply in this thread": "Responder nesta conversa",
  "Report name": "Nome do relatório",
  "Reports": "Relatórios",
  "Request": "Solicitar",
  "Request failed": "A solicitação falhou",
  "Request leave": "Solicitar ausência",
  "Reset your password": "Redefinir sua senha",
  "Result": "Resultado",
  "Resume": "Retomar",
  "Resume (pauses the running timer)": "Retomar (pausa o cronômetro em execução)",
  "Resume this timer (pauses the running one)": "Retomar este cronômetro (pausa o que está em execução)",
  "Retake baseline": "Refazer linha de base",
  "Retention": "Retenção",
  "Return the week with a note; the person edits and resubmits": "Devolver a semana com uma observação; a pessoa edita e reenvia",
  "Revoke the token \"{name}\"? Anything using it stops working immediately.": "Revogar o token “{name}”? Tudo o que o usa para de funcionar imediatamente.",
  "Role": "Papel",
  "Run this report automatically on the chosen cadence and deliver it by email/notification": "Executar este relatório automaticamente na cadência escolhida e entregar por e-mail/notificação",
  "Save": "Salvar",
  "Save every change on this record": "Salvar todas as alterações deste registro",
  "Save policy": "Salvar política",
  "Save policy stores the numbers for the nightly run. Run now purges immediately with the saved policy.": "Salvar política armazena os números para a execução noturna. Executar agora expurga imediatamente com a política salva.",
  "Save the current grouping and filters under a name": "Salvar o agrupamento e filtros atuais com um nome",
  "Save these recovery codes now.": "Salve estes códigos de recuperação agora.",
  "Saved reports…": "Relatórios salvos…",
  "Saved ✓": "Salvo ✓",
  "Saved.": "Salvo.",
  "Schedule": "Agendar",
  "Schedule end": "Fim do cronograma",
  "Schedule settings per project": "Configurações de cronograma por projeto",
  "Scheduled reports": "Relatórios agendados",
  "Scroll the timeline back to today": "Rolar a linha do tempo de volta para hoje",
  "Search": "Buscar",
  "Search code or name…": "Buscar código ou nome…",
  "Search…": "Buscar…",
  "Send the request to your line manager (some types are approved automatically)": "Enviar a solicitação ao seu gerente (alguns tipos são aprovados automaticamente)",
  "Send them a password reset link from the directory when they are ready to sign in.": "Envie um link de redefinição pelo diretório quando a pessoa puder entrar.",
  "Send them this link — it is shown once and expires in 7 days:": "Envie este link — ele é mostrado uma vez e expira em 7 dias:",
  "Send this project-week to the project administrator for approval; you can withdraw until they decide": "Enviar esta semana de projeto ao administrador do projeto para aprovação; você pode retirar até que ele decida",
  "Sent back": "Devolvido",
  "Service account": "Conta de serviço",
  "Set a new password for": "Definir uma nova senha para",
  "Set a password": "Definir uma senha",
  "Set status…": "Definir status…",
  "Set the task and a note when you start, or edit them in the list.": "Defina a tarefa e uma observação ao iniciar, ou edite-as na lista.",
  "Set up your account": "Configure sua conta",
  "Settings": "Configurações",
  "Share with project": "Compartilhar com o projeto",
  "Show": "Mostrar",
  "Show archived": "Mostrar arquivados",
  "Show failed sign-in attempts": "Mostrar tentativas de login com falha",
  "Show service accounts": "Mostrar contas de serviço",
  "Show sign-in attempts": "Mostrar tentativas de login",
  "Show subtasks": "Mostrar subtarefas",
  "Show the audit log": "Mostrar o log de auditoria",
  "Show this project in your lists again": "Mostrar este projeto nas suas listas novamente",
  "Show this project's tasks": "Mostrar as tarefas deste projeto",
  "Show what this comment said before it was edited": "Ver o que este comentário dizia antes de ser editado",
  "Shows their day in the right hours; it never changes which week an entry belongs to.": "Mostra o dia dela nos horários certos; nunca muda a que semana um lançamento pertence.",
  "Sign in": "Entrar",
  "Sign in with your device's fingerprint, face or PIN, or a hardware key — no password or code needed. Passkeys are phishing-resistant.": "Entre com a impressão digital, o rosto ou o PIN do seu dispositivo, ou uma chave física — sem senha nem código. Chaves de acesso resistem a phishing.",
  "Sign out": "Sair",
  "Signed in": "Conectado",
  "Signing in…": "Entrando…",
  "Since": "Desde",
  "Sortable table of tasks across every project in the portfolio": "Tabela ordenável das tarefas de todos os projetos do portfólio",
  "Sortable table of tasks with bulk edit and saved views": "Tabela ordenável de tarefas com edição em massa e visualizações salvas",
  "Start (or switch) your timer for this project onto this task; any running timer pauses": "Iniciar (ou trocar) seu cronômetro deste projeto para esta tarefa; qualquer cronômetro em execução é pausado",
  "Start a timer for this project (pauses any running timer)": "Iniciar um cronômetro para este projeto (pausa qualquer cronômetro em execução)",
  "Start timer": "Iniciar cronômetro",
  "Start timer on this task": "Iniciar cronômetro nesta tarefa",
  "Starts": "Começa",
  "State": "Estado",
  "Stop and save": "Parar e salvar",
  "Stop and save one time entry for the total": "Parar e salvar um lançamento de tempo com o total",
  "Stop and save one time entry for the total on this project": "Parar e salvar um lançamento de tempo com o total neste projeto",
  "Stop anything using this token, immediately": "Parar imediatamente tudo o que usa este token",
  "Stop at idle — save up to the idle moment and stop": "Parar na ociosidade — salvar até o momento ocioso e parar",
  "Stop reading your Google Calendar": "Parar de ler seu Google Agenda",
  "Stop the timer running on this task and save one time entry": "Parar o cronômetro em execução nesta tarefa e salvar um lançamento de tempo",
  "Stop timer": "Parar cronômetro",
  "Store these numbers as the policy; the nightly purge uses them from its next run": "Armazenar estes números como política; o expurgo noturno os usa a partir da próxima execução",
  "Subscribe": "Assinar",
  "Subscribe your calendar app to this link to see your tasks (due dates), leave, your projects' milestones and your last 90 days of time entries.": "Assine este link no seu app de calendário para ver suas tarefas (vencimentos), ausências, os marcos dos seus projetos e seus últimos 90 dias de lançamentos de tempo.",
  "Subscribe your calendar app to your tasks, leave, milestones and recent time entries.": "Assine suas tarefas, ausências, marcos e lançamentos de tempo recentes no seu app de calendário.",
  "Swimlanes": "Raias",
  "System state, the audit trail, and sign-in activity. People and invites are under": "Estado do sistema, trilha de auditoria e atividade de login. Pessoas e convites ficam em",
  "Take baseline": "Tirar linha de base",
  "Take the project out of this portfolio (the project itself is unchanged)": "Tirar o projeto deste portfólio (o projeto em si não muda)",
  "Take the submission back to edit the week; resubmit when ready": "Retirar o envio para editar a semana; reenvie quando estiver pronta",
  "Task": "Tarefa",
  "Task (optional)": "Tarefa (opcional)",
  "Task this timer is for (optional)": "Tarefa à qual este cronômetro se refere (opcional)",
  "Task title": "Título da tarefa",
  "Tasks": "Tarefas",
  "Tasks can't move between projects": "Tarefas não podem ser movidas entre projetos",
  "Tasks live inside projects; open Projects": "As tarefas ficam dentro de projetos; abra Projetos",
  "Team (last 30 days)": "Equipe (últimos 30 dias)",
  "That does not look like a valid zone.": "Isso não parece um fuso válido.",
  "The calendar's public iCal URL": "A URL iCal pública do calendário",
  "The link is a secret — anyone holding it can read your feed. Regenerate it if it leaks.": "O link é secreto — qualquer pessoa com ele pode ler seu feed. Regenere-o se vazar.",
  "The numbers below are the": "Os números abaixo são a",
  "The person accountable for the portfolio; always a portfolio administrator": "A pessoa responsável pelo portfólio; sempre um administrador do portfólio",
  "There is no password yet, so nobody can sign in as them. Issue a password reset link from the directory when they are ready.": "Ainda não há senha, então ninguém pode entrar como essa pessoa. Emita um link de redefinição pelo diretório quando ela estiver pronta.",
  "They can sign in with the password you set.": "A pessoa pode entrar com a senha que você definiu.",
  "This account can only be used from these addresses (set by an administrator):": "Esta conta só pode ser usada a partir destes endereços (definido por um administrador):",
  "This browser does not support passkeys.": "Este navegador não oferece suporte a chaves de acesso.",
  "This invite is invalid or has expired. Ask an administrator for a new one.": "Este convite é inválido ou expirou. Peça um novo a um administrador.",
  "This password is shown once and will not be shown again. Give it to them over a channel you trust; they can change it under Account.": "Esta senha aparece uma única vez e não será mostrada de novo. Passe-a por um canal confiável; a pessoa pode trocá-la em Conta.",
  "Throw this timer away without saving": "Descartar este cronômetro sem salvar",
  "Time": "Tempo",
  "Time is approved per project, per week, in each project's own timezone.": "O tempo é aprovado por projeto, por semana, no fuso horário de cada projeto.",
  "Time off is approved by your line manager and reduces your available capacity for that week — it never counts as hours worked.": "Ausências são aprovadas pelo seu gerente e reduzem sua capacidade disponível naquela semana — nunca contam como horas trabalhadas.",
  "Timeline across projects: cross-project links, critical path": "Linha do tempo entre projetos: vínculos entre projetos, caminho crítico",
  "Timeline: drag bars, link dependencies, critical path, baseline": "Linha do tempo: arraste barras, vincule dependências, caminho crítico, linha de base",
  "Timesheets": "Folhas de horas",
  "Timezone": "Fuso horário",
  "Timezone of truth": "Fuso horário de referência",
  "Title": "Título",
  "Title of the new task; you can fill in the rest from the task editor": "Título da nova tarefa; você pode preencher o resto no editor de tarefas",
  "To": "Até",
  "To confirm, type your name exactly:": "Para confirmar, digite seu nome exatamente:",
  "To connect Claude Code as this account, put the token in the shell and add the server once:": "Para conectar o Claude Code como esta conta, coloque o token no shell e adicione o servidor uma vez:",
  "To do": "A fazer",
  "Token name, e.g. Claude Code": "Nome do token, p. ex. Claude Code",
  "Top": "Topo",
  "Turn off": "Desativar",
  "Turn off authenticator": "Desativar autenticador",
  "Turn on": "Ativar",
  "Type": "Tipo",
  "Type @ to mention someone · Ctrl-Enter posts": "Digite @ para mencionar alguém · Ctrl-Enter publica",
  "Type a command, project, task key, or name…  (Ctrl-K toggles)": "Digite um comando, projeto, chave de tarefa ou nome…  (Ctrl-K alterna)",
  "Type your display name exactly to enable the final button": "Digite seu nome de exibição exatamente para habilitar o botão final",
  "Unarchive": "Desarquivar",
  "Unassigned": "Não atribuído",
  "Unlock an approved week for edits; requires a reason, recorded in the audit log, and notifies the person": "Desbloquear uma semana aprovada para edição; requer um motivo, registrado no log de auditoria, e notifica a pessoa",
  "Unshare": "Deixar de compartilhar",
  "Upcoming milestones": "Próximos marcos",
  "Update password": "Atualizar senha",
  "Upload": "Enviar",
  "Use them to try a change with a few people first, or to switch a feature off quickly if it misbehaves.": "Use-os para testar uma mudança com poucas pessoas primeiro, ou para desligar rapidamente um recurso que esteja com problema.",
  "Velocity": "Velocidade",
  "Velocity (estimate hours done per week)": "Velocidade (horas estimadas concluídas por semana)",
  "Velocity per week": "Velocidade por semana",
  "Verify": "Verificar",
  "Views…": "Visualizações…",
  "WIP limit": "Limite de WIP",
  "Week": "Semana",
  "Week of": "Semana de",
  "Weeks awaiting submission": "Semanas aguardando envio",
  "Weeks from": "Semanas a partir de",
  "Weeks run Monday→Monday in": "As semanas vão de segunda a segunda em",
  "What": "O quê",
  "What did you work on?": "No que você trabalhou?",
  "What they see the app in until they choose otherwise.": "O idioma em que a pessoa vê o app até escolher outro.",
  "What this person costs per hour (effective-dated); click to view history or change it": "Quanto esta pessoa custa por hora (com data de vigência); clique para ver o histórico ou alterar",
  "When": "Quando",
  "When done, the next occurrence is created with dates shifted.": "Ao concluir, a próxima ocorrência é criada com as datas deslocadas.",
  "Where password resets go. Change it and they are emailed about it.": "É para onde vão as redefinições de senha. Se você mudar, a pessoa é avisada por e-mail.",
  "Which project the new timer is for": "A qual projeto pertence o novo cronômetro",
  "Who": "Quem",
  "Working days per week": "Dias úteis por semana",
  "Write a comment…": "Escreva um comentário…",
  "Write a reply…": "Escreva uma resposta…",
  "You are not a member of any project yet, so there is nowhere to log time. Ask a project administrator to add you.": "Você ainda não é membro de nenhum projeto, então não há onde registrar tempo. Peça a um administrador de projeto para adicioná-lo.",
  "You become its portfolio manager; add projects and members from the portfolio page, or file a project from its": "Você se torna o gerente do portfólio; adicione projetos e membros na página do portfólio, ou inclua um projeto pela página dele, em",
  "You can also send them the link directly:": "Você também pode enviar o link diretamente:",
  "You can see this project's tasks here but not change them": "Você pode ver as tarefas deste projeto aqui, mas não alterá-las",
  "You do not have access to this page.": "Você não tem acesso a esta página.",
  "You have been invited as": "Você foi convidado como",
  "You have no line manager set, so requests will wait for an administrator. Ask an admin to set your manager under People.": "Você não tem gerente definido, então as solicitações aguardarão um administrador. Peça a um admin para definir seu gerente em Pessoas.",
  "You need edit rights in both projects to link them": "Você precisa de direitos de edição nos dois projetos para vinculá-los",
  "You sign in with Google, which handles two-factor authentication for you. These options apply to password sign-in.": "Você entra com o Google, que cuida da autenticação em dois fatores por você. Estas opções se aplicam ao login com senha.",
  "You sign in with Google. A password gives you a fallback if Google is unavailable.": "Você entra com o Google. Uma senha oferece uma alternativa caso o Google esteja indisponível.",
  "Your colleagues.": "Seus colegas.",
  "Your feed (out)": "Seu feed (saída)",
  "Your name": "Seu nome",
  "Your own zone, for display. Projects keep their own timezone-of-truth.": "Seu próprio fuso, para exibição. Os projetos mantêm seu fuso horário de referência.",
  "Your role": "Seu papel",
  "Your role requires a second factor for password sign-in. Set up an": "Seu papel exige um segundo fator para login com senha. Configure um",
  "Your week is shown in": "Sua semana é mostrada em",
  "active people": "pessoas ativas",
  "active projects": "projetos ativos",
  "approvals arrive in Phase 3": "aprovações chegam na Fase 3",
  "archived": "arquivado",
  "assignee: clear": "responsável: limpar",
  "assignee: keep": "responsável: manter",
  "audit trail for this project": "trilha de auditoria deste projeto",
  "billable hours": "horas faturáveis",
  "billed amount": "valor faturado",
  "by": "por",
  "change in Settings": "alterar em Configurações",
  "closes Monday": "fecha na segunda",
  "comments and @mentions about the project as a whole": "comentários e @menções sobre o projeto como um todo",
  "correction": "correção",
  "cost": "custo",
  "cost / hour": "custo / hora",
  "created": "criado",
  "created → done": "criado → concluído",
  "critical tasks": "tarefas críticas",
  "current": "atual",
  "current + new + confirm": "atual + nova + confirmar",
  "current 6-digit code": "código atual de 6 dígitos",
  "days": "dias",
  "deleted": "excluído",
  "description, dashboard": "descrição, painel",
  "devices signed in as you": "dispositivos conectados como você",
  "done": "concluído",
  "download everything stored about you": "baixe tudo o que está armazenado sobre você",
  "due +days": "vencimento +dias",
  "edited": "editado",
  "edited by": "editado por",
  "estimate hours": "horas estimadas",
  "every 2 weeks": "a cada 2 semanas",
  "every day": "todo dia",
  "every month": "todo mês",
  "every quarter": "todo trimestre",
  "every week": "toda semana",
  "extra recipients (comma-separated)": "destinatários extras (separados por vírgula)",
  "failed sign-ins (24h)": "logins com falha (24h)",
  "feed URL, Google Calendar, external calendars": "URL do feed, Google Agenda, calendários externos",
  "fingerprint, face, security key": "impressão digital, rosto, chave de segurança",
  "from": "de",
  "generate one and show it to me once": "gerar uma e mostrá-la uma vez",
  "hidden": "oculto",
  "hours": "horas",
  "hours and money caps, alerts": "limites de horas e dinheiro, alertas",
  "hours logged": "horas registradas",
  "hours logged (yours where restricted)": "horas registradas (as suas onde houver restrição)",
  "iCal subscription link": "link de assinatura iCal",
  "in": "em",
  "in progress": "em andamento",
  "kept": "mantido",
  "last 30 days": "últimos 30 dias",
  "last month": "mês passado",
  "last week": "semana passada",
  "latest scheduled finish across projects": "término agendado mais tardio entre os projetos",
  "list view, editor, checklists": "visão em lista, editor, listas de verificação",
  "live sessions": "sessões ativas",
  "logged this week": "registrado esta semana",
  "median cycle time (days)": "tempo de ciclo mediano (dias)",
  "median lead time (days)": "lead time mediano (dias)",
  "migrations": "migrações",
  "month to date": "mês até hoje",
  "name, dates, timezone, archive": "nome, datas, fuso, arquivar",
  "name, description, portfolio manager, archive": "nome, descrição, gerente do portfólio, arquivar",
  "name, language, timezone": "nome, idioma, fuso horário",
  "navigate · Enter run · Esc close": "navegar · Enter executar · Esc fechar",
  "never": "nunca",
  "no estimates yet": "ainda sem estimativas",
  "no rate — billable time counts as unrated": "sem taxa — o tempo faturável conta como sem taxa",
  "no scheduled tasks yet": "ainda sem tarefas agendadas",
  "non-billable": "não faturável",
  "none yet": "nenhuma ainda",
  "none — portfolio views assign a palette colour": "nenhuma — as visões de portfólio atribuem uma cor da paleta",
  "none — they cannot sign in yet": "nenhuma — a pessoa ainda não pode entrar",
  "now has an account.": "agora tem uma conta.",
  "off": "desligado",
  "office, home…": "escritório, casa…",
  "on": "ligado",
  "open tasks assigned to me": "tarefas abertas atribuídas a mim",
  "or set a password": "ou defina uma senha",
  "or use a password": "ou use uma senha",
  "overdue": "atrasado",
  "overdue ·": "atrasado ·",
  "payroll-ready": "pronto para a folha",
  "people are": "pessoas estão",
  "permanent — read first": "pessoa está",
  "person is": "permanente — leia primeiro",
  "person's zone": "fuso da pessoa",
  "policy": "política",
  "portfolio": "portfólio",
  "portfolio administrator": "administrador do portfólio",
  "portfolio end": "fim do portfólio",
  "priority: keep": "prioridade: manter",
  "private": "privado",
  "project administrator": "administrador do projeto",
  "project zone": "fuso do projeto",
  "projected finish": "término projetado",
  "projects": "projetos",
  "rate / hour": "taxa / hora",
  "read this once": "leia uma vez",
  "read-only": "somente leitura",
  "rejected — resubmit": "rejeitado — reenviar",
  "service account": "conta de serviço",
  "set one now": "definir uma agora",
  "subtask": "subtarefa",
  "synced": "sincronizado",
  "system": "sistema",
  "taken": "tirada em",
  "task count": "contagem de tarefas",
  "tasks": "tarefas",
  "tasks done": "tarefas concluídas",
  "then": "depois",
  "this device": "este dispositivo",
  "this week": "esta semana",
  "throughput": "vazão",
  "time entries": "lançamentos de tempo",
  "time-based codes (TOTP)": "códigos temporais (TOTP)",
  "to": "até",
  "to do": "a fazer",
  "two-way sync": "sincronização bidirecional",
  "unassigned": "não atribuído",
  "updated": "atualizado",
  "velocity (h / week)": "velocidade (h / semana)",
  "week start": "início da semana",
  "weeks awaiting submission": "semanas aguardando envio",
  "workflow columns and transitions": "colunas de fluxo e transições",
  "your hours logged": "suas horas registradas",
  "your password": "sua senha",
  "zero slack: a delay moves the end date": "folga zero: um atraso move a data final",
  "{n} people notified": "{n} pessoas notificadas",
  "{n} private projects are hidden from these totals.": "{n} projetos privados estão ocultos nestes totais.",
  "{n} private projects hidden": "{n} projetos privados ocultos",
  "{n} projects": "{n} projetos",
  "— (top level)": "— (nível superior)",
  "— no task —": "— sem tarefa —",
  "— none —": "— nenhum —",
  "— unassigned —": "— não atribuído —",
  "🔒 approved": "🔒 aprovado",
  "Task completed.": "Tarefa concluída.",
  "Task reopened.": "Tarefa reaberta.",
  "+ sub": "+ sub",
  "Burndown / burnup": "Burndown / burnup",
  "Est.": "Est.",
  "Gantt": "Gantt",
  "Lead (d)": "Lead (d)",
  "Status": "Status",
  "Total": "Total",
  "Zoom": "Zoom",
  "est. h": "est. h",
  "predecessor": "predecessor",
  "Applies immediately to this browser and every device you sign in on; overrides the browser language.": "Aplica-se imediatamente a este navegador e a todos os dispositivos em que você entrar; substitui o idioma do navegador.",
  "A confirmation link was sent to the new address (valid 2 days). Your email changes when you open it.": "Um link de confirmação foi enviado ao novo endereço (válido por 2 dias). Seu e-mail muda quando você o abrir.",
  "Cancel it": "Cancelar",
  "Change email": "Alterar e-mail",
  "Change now": "Alterar agora",
  "Change now (with password)": "Alterar agora (com senha)",
  "Change the email immediately": "Alterar o e-mail imediatamente",
  "Changed. Use the new address next time you sign in.": "Alterado. Use o novo endereço na próxima vez que entrar.",
  "Confirm email": "Confirmar e-mail",
  "Done — your sign-in email is now": "Pronto — seu e-mail de login agora é",
  "Either way the old address is told, and the change is recorded in the audit log.": "De qualquer forma o endereço antigo é avisado e a alteração fica no log de auditoria.",
  "Mail is not configured on this server, so open this link yourself (valid 2 days):": "O e-mail não está configurado neste servidor, então abra este link você mesmo (válido por 2 dias):",
  "New email": "Novo e-mail",
  "Send a confirmation link to the new address": "Enviar um link de confirmação ao novo endereço",
  "Send confirmation link": "Enviar link de confirmação",
  "This account signs in with Google, so its email is managed by Google and cannot be changed here.": "Esta conta entra com o Google, então seu e-mail é gerenciado pelo Google e não pode ser alterado aqui.",
  "Verify first": "Verificar primeiro",
  "Verify first (send a link)": "Verificar primeiro (enviar um link)",
  "Waiting for confirmation of": "Aguardando confirmação de",
  "Your email is what you sign in with and where notifications are mailed.": "Seu e-mail é com o que você entra e para onde as notificações são enviadas.",
  "a link is sent to the new address; the change happens when you open it, so a typo can't lock you out.": "um link é enviado ao novo endereço; a alteração acontece quando você o abre, então um erro de digitação não pode deixá-lo de fora.",
  "enter your current password and the address changes immediately.": "digite sua senha atual e o endereço muda imediatamente.",
  "expires": "expira",
  "A status update is waiting to be sent to GitHub": "Uma atualização de status está aguardando envio ao GitHub",
  "API calls left this hour": "chamadas de API restantes nesta hora",
  "Assign to matching people": "Atribuir às pessoas correspondentes",
  "Close and reopen issues when task status changes": "Fechar e reabrir issues quando o status da tarefa mudar",
  "Connect": "Conectar",
  "Connect a repository to import its issues as tasks. When a task is finished here, the issue is closed on GitHub; when an issue is closed or reopened on GitHub, the task follows.": "Conecte um repositório para importar suas issues como tarefas. Quando uma tarefa é concluída aqui, a issue é fechada no GitHub; quando uma issue é fechada ou reaberta no GitHub, a tarefa acompanha.",
  "Connected to": "Conectado a",
  "Could not load the GitHub connection.": "Não foi possível carregar a conexão com o GitHub.",
  "Create missing milestones": "Criar marcos ausentes",
  "Disconnect": "Desconectar",
  "Disconnect this repository? Existing issue links are kept; nothing is deleted on GitHub.": "Desconectar este repositório? Os links de issues existentes são mantidos; nada é excluído no GitHub.",
  "Fine-grained personal access token": "Token de acesso pessoal refinado",
  "GITHUB_WEBHOOK_SECRET is not set on the server, so changes made on GitHub reach APM by hourly polling or “Sync now” rather than instantly.": "GITHUB_WEBHOOK_SECRET não está definido no servidor, então as mudanças feitas no GitHub chegam ao APM por verificação de hora em hora ou por “Sincronizar agora”, não instantaneamente.",
  "GitHub": "GitHub",
  "GitHub username": "Usuário do GitHub",
  "GitHub → Settings → Developer settings → Fine-grained tokens. Limit it to this repository with permission Issues: Read and write (Metadata is included automatically). The token is verified now, stored encrypted, and never shown again.": "GitHub → Settings → Developer settings → Fine-grained tokens. Limite-o a este repositório com a permissão Issues: Read and write (Metadata é incluído automaticamente). O token é verificado agora, guardado criptografado e nunca mais exibido.",
  "Import issues": "Importar issues",
  "Import issues…": "Importar issues…",
  "Importing…": "Importando…",
  "Issue closed as completed →": "Issue fechada como concluída →",
  "Issue closed as not planned →": "Issue fechada como não planejada →",
  "Issue reopened →": "Issue reaberta →",
  "Issues assigned to this GitHub user become tasks assigned to you when a project imports them.": "Issues atribuídas a este usuário do GitHub viram tarefas atribuídas a você quando um projeto as importa.",
  "Labels": "Rótulos",
  "Mirror the task status as an apm:… label": "Espelhar o status da tarefa como rótulo apm:…",
  "Moving a task into this status closes the issue as “not planned”; any other done status closes it as “completed”.": "Mover uma tarefa para este status fecha a issue como “não planejada”; qualquer outro status concluído a fecha como “concluída”.",
  "No APM account has this GitHub username": "Nenhuma conta do APM tem este usuário do GitHub",
  "No issues match.": "Nenhuma issue corresponde.",
  "Priority from labels": "Prioridade a partir de rótulos",
  "Replace the token or test the connection to resume.": "Substitua o token ou teste a conexão para retomar.",
  "Replace token": "Substituir token",
  "Repository": "Repositório",
  "Status mapping": "Mapeamento de status",
  "Sync history": "Histórico de sincronização",
  "Sync is paused:": "A sincronização está pausada:",
  "Sync now": "Sincronizar agora",
  "Synced:": "Sincronizado:",
  "Syncing…": "Sincronizando…",
  "Test connection": "Testar conexão",
  "Webhook: add": "Webhook: adicione",
  "When an imported issue carries one of these labels, the task gets the matching priority (first match wins).": "Quando uma issue importada tem um destes rótulos, a tarefa recebe a prioridade correspondente (a primeira correspondência vale).",
  "all": "todas",
  "already linked": "já vinculadas",
  "attempt": "tentativa",
  "checked": "verificadas",
  "closed": "fechada",
  "create": "criar",
  "errors": "erros",
  "failed": "falhas",
  "first done status": "primeiro status concluído",
  "first to-do status": "primeiro status a fazer",
  "import issues as tasks, sync status": "importar issues como tarefas, sincronizar status",
  "label, e.g. bug": "rótulo, ex. bug",
  "labels, comma-separated": "rótulos, separados por vírgula",
  "last checked": "última verificação",
  "linked issues": "issues vinculadas",
  "next": "próxima",
  "not planned": "não planejada",
  "nothing to do": "nada a fazer",
  "open": "aberta",
  "open issues": "issues abertas",
  "page": "página",
  "previous": "anterior",
  "remove": "remover",
  "running": "em execução",
  "same as completed": "igual a concluída",
  "search title or #number": "buscar título ou #número",
  "sent to GitHub": "enviadas ao GitHub",
  "to the repository with the server's GITHUB_WEBHOOK_SECRET, content type JSON, events: Issues, Pushes, Pull requests. Without it, changes still arrive by hourly polling or “Sync now”.": "ao repositório com o GITHUB_WEBHOOK_SECRET do servidor, tipo de conteúdo JSON, eventos: Issues, Pushes, Pull requests. Sem ele, as mudanças ainda chegam por verificação de hora em hora ou por “Sincronizar agora”.",
  "token": "token",
  "update": "atualizar",
  "update pending": "atualização pendente",
  "updated here": "atualizadas aqui",
  "updates waiting": "atualizações aguardando",
  "Open menu": "Abrir menu",
  "Close menu": "Fechar menu",
  "Main menu": "Menu principal",
  "Management": "Gestão",
}
